import { useQuery } from "@tanstack/react-query";
import type { LimitedUseRxNavQueryOptions, RxNavQueryRequests } from "./types";

export interface UseRxNavDisplayNamesQueryArgs<TError = Error, TData = RxNavQueryRequests["display-names"]["response"]>
  extends LimitedUseRxNavQueryOptions<"display-names", TError, TData> {}

export const useRxNavDisplayNames = <TError = Error, TData = RxNavQueryRequests["display-names"]["response"]>(
  options?: UseRxNavDisplayNamesQueryArgs<TError, TData>
) =>
  useQuery({
    queryKey: ["rx-nav", "display-names"],
    queryFn: async () => {
      const result = await fetch("https://rxnav.nlm.nih.gov/REST/displaynames.json");
      return await result.json();
    },
    ...options,
  });
